export default "__VITE_ASSET__ChuhL_Ko__"